<span class="pin-icon" [class.pin-pinned]="isPinned">
    <vn-icon [name]="isPinned ? 'theme-pin-pinned' : 'theme-pin-unpinned'" [size]="isEpcotEnabled() ? '14' : '16'" />
</span>
